<template>
  <div class="rate-limiter" data-test-id="rate-limit">
    {{
      $t('general/error/rate-limit-remaining', {
        TIME: formatSeconds(secondsLeft)
      })
    }}
  </div>
</template>
<script setup>

const emit = defineEmits(['ended'])
const props = defineProps({
  secondsLeft: {
    type: Number,
    required: true
  }
})

watch(() => props.secondsLeft, () => {
  if (props.secondsLeft <= 0) {
    emit('ended')
  }
})

const formatSeconds = seconds => {
  const date = new Date(0)
  date.setSeconds(seconds)

  return date.toLocaleTimeString('en-US', {
    minute: '2-digit',
    second: '2-digit'
  })
}

</script>
